<template>
  <button
    class="upgrade-button"
    :class="{ compact, bordered }"
    @click="handleClick"
    data-testid="upgrade-button"
  >
    <img :src="upgradeCrownOutline" alt="" class="crown-icon" />
    <span class="button-text">Upgrade</span>
  </button>
</template>

<script lang="ts" setup>
import upgradeCrownOutline from './upgrade-crown-outline.svg';

interface Props {
  compact?: boolean;
  bordered?: boolean;
  onClick?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  compact: false,
  bordered: false,
});

const emit = defineEmits<{
  click: [];
}>();

const handleClick = () => {
  if (props.onClick) {
    props.onClick();
  }
  emit('click');
};
</script>

<style scoped>
.upgrade-button {
  @apply relative flex items-center gap-1.5 h-9 rounded-lg bg-transparent px-3 py-2 transition-all active:scale-95 cursor-pointer;
}

.upgrade-button.bordered {
  @apply border border-orange-500 dark:border-orange-400;
}

.upgrade-button.compact {
  @apply h-8 px-2.5 py-1.5 gap-1;
}

/* Hover state */
.upgrade-button:hover {
  @apply bg-orange-50 dark:bg-orange-900/20;
}

.button-text {
  @apply text-sm font-semibold text-orange-500 dark:text-orange-400;
}

.crown-icon {
  @apply w-[18px] h-[18px] flex-shrink-0;
}

.upgrade-button.compact .crown-icon {
  @apply w-4 h-4;
}

.upgrade-button.compact .button-text {
  @apply text-xs;
}
</style>
